export var ExpenseChart = {
  series: [42, 47, 52, 58],
  labels: ["Rose A", "Rose B", "Rose C", "Rose D"],
  chart: {
    height: 350,
    type: "polarArea",
  },
  fill: {
    opacity: 1,
    colors: [
      "var(--theme-color2)",
      "var(--primary-color)",
      "var(--theme-color3)",
      "var(--theme-color1)",
    ],
  },
  stroke: {
    width: 2,
    colors: ["#fff"],
  },
  yaxis: {
    show: false,
    labels: {
      show: false,
    },
  },
  legend: {
    position: "bottom",
    show: false,
  },
  plotOptions: {
    polarArea: {
      rings: {
        strokeWidth: 0,
      },
      spokes: {
        strokeWidth: 0,
      },
    },
  },
  theme: {
    monochrome: {
      enabled: true,
      shadeTo: "light",
      shadeIntensity: 0.6,
    },
  },
};
